import React, { useEffect, useRef, useState } from 'react'
import Header from '../../common/header/Header'
import Footer from '../../common/footer/Footer'
import { Link, useNavigate } from 'react-router-dom'
import { Add_To_Fav, Get_Product_List_Category_wise, Category_List, Sub_Category_List, Product_List_Data_Category_wise } from '../../../api/category_product/Category_Product'

import Loader from '../../../loader/Loader'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../config/Config';
import { User_Authentication } from '../../../user_authentication/User_Authentication'
import { toast } from 'react-toastify'
import Common_Images_Transport from '../../common/common_imges_transport/Common_Images_Transport'

import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux';
import { fetchWishlist } from '../../../redux/actions/wishlistActions';
import { fetchCartList } from '../../../redux/actions/cartActions'

import { useParams } from 'react-router-dom';
import { fetchSettingData } from '../../../redux/actions/settingAction'

const Product_List = () => {
    const [is_loading, set_set_Is_Loading] = useState(false)
    const { categorySlug, subCategorySlug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { settingData } = useSelector(
        (state) => state?.settingdata || []
    );


    const [cat_obj, set_Cat_Obj] = useState()
    const [sub_Cate_obj, setSubCategoryObject] = useState()
    const [products, setProducts] = useState([])
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const Get_user_is_active = localStorage.getItem("user_is_active")
    const productsPerPage = 12;

    const [is_Open_filter, set_Is_Open_filter] = useState(false);
    const [is_Open_Origin, set_Is_Open_Origin] = useState(false);
    const [is_Open_Shape, set_Is_Open_Shape] = useState(false);
    const [is_Open_Cut, set_Is_Open_Cut] = useState(false);
    const [is_Open_Certificate, set_Is_Open_Certificate] = useState(false);

    const [is_Open_Color, set_Is_Open_Color] = useState(false);
    const [is_Open_Composition, set_Is_Open_Composition] = useState(false);

    const [is_Open_treatment, set_Is_Open_treatment] = useState(false);
    const [is_Open_price, set_Is_Open_price] = useState(false);

    const [selectedOrigins, setSelectedOrigins] = useState([]);
    const [selectedShape, setSelectedShape] = useState([]);
    const [selectedCut, setSelectedCut] = useState([]);
    const [selectedCertificate, setSelectedCertificate] = useState([]);
    const [selectedColor, setSelectedColor] = useState([]);
    const [selectedComposition, setSelectedComposition] = useState([]);
    const [selectedTreatment, setSelectedTreatment] = useState([]);
    const [price, setPrice] = useState([0, 100000]);

    const [minPrice, setMinPrice] = useState("0");
    const [maxPrice, setMaxPrice] = useState("");
    const get_category_list_result_slug = localStorage.getItem("category_list_result_slug")
    const [show_video, set_show_video] = useState(false)
    const [categoryPage, setCategoryPage] = useState(null)

    const [video, set_video] = useState("https://rasatva.parasmesoft.in/omens/public/uploads/product/videos/19056.mp4")

    const originRef = useRef(null);
    const shapeRef = useRef(null);
    const certificateRef = useRef(null);
    const cutRef = useRef(null);
    const colorRef = useRef(null);
    const compositionRef = useRef(null);
    const treatmentRef = useRef(null);
    const priceRef = useRef(null);

    useEffect(() => {
        dispatch(fetchSettingData())
    }, [dispatch]);


    useEffect(() => {
        setMinPrice(price[0])
        setMaxPrice(price[1])
    }, [price])

    useEffect(() => {
        setSelectedOrigins([])
        setSelectedTreatment([])
        setSelectedComposition([])
        setSelectedColor([])
        setSelectedCertificate([])
        setSelectedCut([])
        setSelectedShape([])
        setMaxPrice("")
        setMinPrice("0")

        set_Is_Open_price(false)
        set_Is_Open_treatment(false)
        set_Is_Open_Composition(false)
        set_Is_Open_Color(false)
        set_Is_Open_Cut(false)
        set_Is_Open_Certificate(false)
        set_Is_Open_Shape(false)
        set_Is_Open_Origin(false)

    }, [sub_Cate_obj, cat_obj])

    // close filterdropdown click on outside the opened dropdown
    const handleClickOutside = (event) => {

        if (originRef.current && !originRef.current.contains(event.target)) {
            set_Is_Open_Origin(false);

        }
        if (shapeRef.current && !shapeRef.current.contains(event.target)) {
            set_Is_Open_Shape(false);

        }
        if (certificateRef.current && !certificateRef.current.contains(event.target)) {
            set_Is_Open_Certificate(false);

        }
        if (cutRef.current && !cutRef.current.contains(event.target)) {
            set_Is_Open_Cut(false);

        }
        if (colorRef.current && !colorRef.current.contains(event.target)) {
            set_Is_Open_Color(false);

        }
        if (compositionRef.current && !compositionRef.current.contains(event.target)) {
            set_Is_Open_Composition(false);

        }
        if (treatmentRef.current && !treatmentRef.current.contains(event.target)) {
            set_Is_Open_treatment(false);

        }
        if (priceRef.current && !priceRef.current.contains(event.target)) {
            set_Is_Open_price(false);

        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);

        };
    }, []);

    // Calculate total pages safely
    const totalPages = Math.ceil(products?.product?.length / productsPerPage) || 1;

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = products?.product?.slice(startIndex, startIndex + productsPerPage) || [];

    // category page controls
    const handleCategoryPage = (id) => {
        if (categoryPage == id) {
            setCategoryPage(null)
        } else {
            setCategoryPage(id)
        }
    }

    const handlePlay_Video = (video_url) => {
        set_video(`${IMG_BASE_URL}${video_url}`)
        set_show_video(true)
    }

    // Pagination controls
    const getPaginationItems = () => {
        const items = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            if (currentPage <= 3) {
                items.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                items.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                items.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return items;
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const toggle_origin_accordion = (e) => {
        e.stopPropagation();
        set_Is_Open_Origin(!is_Open_Origin);
    };

    const toggle_Shape_accordion = () => {
        set_Is_Open_Shape(!is_Open_Shape);
    };
    const toggle_Cut_accordion = () => {
        set_Is_Open_Cut(!is_Open_Cut);
    };
    const toggle_Certificate_accordion = () => {
        set_Is_Open_Certificate(!is_Open_Certificate);
    };
    const toggle_color_accordion = () => {
        set_Is_Open_Color(!is_Open_Color);
    };
    const toggle_composition_accordion = () => {
        set_Is_Open_Composition(!is_Open_Composition);
    };

    const toggle_treatment_accordion = () => {
        set_Is_Open_treatment(!is_Open_treatment);
    };

    const toggle_treatment_price = () => {
        set_Is_Open_price(!is_Open_price);
    };

    // <------------ handle origin Checkbox Change ----------->
    const handle_origin_Checkbox_Change = (originName) => {
        setSelectedOrigins((prevSelected) =>
            prevSelected?.includes(originName)
                ? prevSelected?.filter((name) => name !== originName)
                : [...prevSelected, originName]
        );
        set_Is_Open_Origin(false)
    };

    // Comma-separated list of selected IDs
    const selectedOriginsString = selectedOrigins.join(',');

    // <------------ handle Shape Checkbox Change ----------->
    const handle_shape_Checkbox_Change = (ShapeName) => {
        setSelectedShape((prevSelected) =>
            prevSelected?.includes(ShapeName)
                ? prevSelected?.filter((name) => name !== ShapeName)
                : [...prevSelected, ShapeName]
        );
        set_Is_Open_Shape(false)
    };
    const selectedShapeString = selectedShape.join(',');

    // <------------ handle Cut Checkbox Change ----------->
    const handle_cut_Checkbox_Change = (CutName) => {
        setSelectedCut((prevSelected) =>
            prevSelected?.includes(CutName)
                ? prevSelected?.filter((name) => name !== CutName)
                : [...prevSelected, CutName]
        );
        set_Is_Open_Cut(false)
    };
    const selectedCutString = selectedCut.join(',');

    // <------------ handle Certifiate Checkbox Change ----------->
    const handle_certificate_Checkbox_Change = (CertificateName) => {
        setSelectedCertificate((prevSelected) =>
            prevSelected?.includes(CertificateName)
                ? prevSelected?.filter((name) => name !== CertificateName)
                : [...prevSelected, CertificateName]
        );
        set_Is_Open_Certificate(false)
    };
    const selectedCertificateString = selectedCertificate.join(',');

    // <------------ handle Color Checkbox Change ----------->
    const handle_color_Checkbox_Change = (ColorName) => {
        setSelectedColor((prevSelected) =>
            prevSelected?.includes(ColorName)
                ? prevSelected?.filter((name) => name !== ColorName)
                : [...prevSelected, ColorName]
        );
        set_Is_Open_Color(false)
    };
    const selectedColorString = selectedColor.join(',');

    // <------------ handle Composition Checkbox Change ----------->
    const handle_composition_Checkbox_Change = (CompositionName) => {
        setSelectedComposition((prevSelected) =>
            prevSelected?.includes(CompositionName)
                ? prevSelected?.filter((name) => name !== CompositionName)
                : [...prevSelected, CompositionName]
        );
        set_Is_Open_Composition(false)
    };
    const selectedCompositionString = selectedComposition.join(',');

    // <------------ handle Treatment Checkbox Change ----------->
    const handle_treatment_Checkbox_Change = (treatmentName) => {
        setSelectedTreatment((prevSelected) =>
            prevSelected?.includes(treatmentName)
                ? prevSelected?.filter((name) => name !== treatmentName)
                : [...prevSelected, treatmentName]
        );
        set_Is_Open_treatment(false)

    };
    const selectedTreatmentString = selectedTreatment.join(',');

    const handleMinChange = (e) => {
        const newMin = Number(e.target.value);
        // Prevent min > max
        if (newMin <= price[1]) {
            setPrice([newMin, price[1]]);
        }
    };

    const handleMaxChange = (e) => {
        const newMax = Number(e.target.value);
        // Prevent max < min
        if (newMax >= price[0]) {
            setPrice([price[0], newMax]);
        }
    };

    // <--------- Add To Favorite --------->
    const Handle_add_to_favorite = async (id, cat_id, sub_id) => {
        // set_set_Is_Loading(true)
        const data = {
            cat_id: cat_id,
            subcat_id: sub_id,
            product_id: id
        }
        try {
            const token = User_Authentication();
            if (!token) {
                toast.error("User not login here")
                set_set_Is_Loading(false);
                throw new Error("User token not found");
            }
            if (!Get_user_is_active) {
                // set_set_Is_Loading(false);
                toast.error("User not login here")
                return
            }
            const response = await Add_To_Fav(data, { Authorization: `Bearer ${token}` })
            if (response?.status == "200") {

                toast.success(response?.data?.message)
                dispatch(fetchWishlist())
                setProducts((prev) => {
                    const updatedProducts = prev?.product?.map((product) =>
                        product?.id === id
                            ? { ...product, is_favourite: !product?.is_favourite }
                            : product
                    );

                    return {
                        ...prev,
                        product: updatedProducts,
                    };
                });
                // fetchEverything();
                // Handle_Get_Product_List({ Authorization: `Bearer ${token}` })
                // set_set_Is_Loading(false)
            }
            else if (response?.response?.data?.status == "500") {
                // set_set_Is_Loading(false)
            }
        }
        catch (error) {
            set_set_Is_Loading(false)
        }
    }

    useEffect(() => {
        const fetchCategoryAndSubcategory = async () => {
            if (!categorySlug || !subCategorySlug) return;
            set_set_Is_Loading(true);

            try {
                const catResponse = await Category_List();
                const categories = catResponse?.data?.data?.category || [];
                const filtered_category = categories.find(cat => cat.slug === categorySlug);
                if (!filtered_category) {
                    toast.error(`${categorySlug} Category not found`);
                    navigate('/', { replace: true });
                    return;
                }

                set_Cat_Obj(filtered_category);
                const subRes = await Sub_Category_List({ cat_id: filtered_category.id });
                const subcategories = subRes?.data?.data?.sub_category || [];
                const filtered_sub = subcategories.find(sub => sub.slug === subCategorySlug);

                if (!filtered_sub) {
                    toast.error(`${subCategorySlug} Subcategory not found`);
                    navigate('/', { replace: true });
                    return;
                }

                setSubCategoryObject(filtered_sub);
            } catch (error) {
                console.error("Error fetching category/subcategory:", error);
            } finally {
                set_set_Is_Loading(false);
            }
        };

        fetchCategoryAndSubcategory();
    }, [categorySlug, subCategorySlug]);

    useEffect(() => {
        const fetchProducts = async () => {
            if (!cat_obj || !sub_Cate_obj) return;

            const productPayload = {
                ...(sub_Cate_obj?.type?.id !== 10 && { category_id: cat_obj.id }),
                subcategory_id: sub_Cate_obj.id,
                origin_id: selectedOriginsString,
                shape_id: selectedShapeString,
                cut_id: selectedCutString,
                certificate_id: selectedCertificateString,
                color_id: selectedColorString,
                composition_id: selectedCompositionString,
                treatment_id: selectedTreatmentString,
                min_amount: minPrice,
                max_amount: maxPrice,
            };

            try {
                let response;

                if (Get_user_is_active) {
                    const token = User_Authentication();
                    if (!token) throw new Error("User not authenticated");

                    try {
                        response = await Get_Product_List_Category_wise(productPayload, {
                            Authorization: `Bearer ${token}`,
                        });

                        // If success
                        if (response?.data?.status == 200) {
                            setProducts(response?.data?.data || []);
                            return;
                        }
                        if (response?.response?.data?.status == 401) {
                            // If 401, clear token and fallback
                            toast.error(response?.response?.data?.message || "Session expired. Showing public data.");
                            localStorage.removeItem("user_token");
                            localStorage.removeItem("user_is_active");
                        }
                    } catch (error) {
                        // If 401, clear token and fallback
                        console.error("Error fetching products:", error);

                    }
                }

                //  Fallback to unauthenticated API
                const publicResponse = await Product_List_Data_Category_wise(productPayload);

                if (publicResponse?.data?.status == 200) {
                    setProducts(publicResponse?.data?.data || []);
                }

            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        fetchProducts();
    }, [
        cat_obj,
        sub_Cate_obj,
        selectedOriginsString,
        selectedShapeString,
        selectedCutString,
        selectedCertificateString,
        selectedColorString,
        selectedCompositionString,
        selectedTreatmentString,
        minPrice,
        maxPrice,
        Get_user_is_active,
    ]);

    const handleNavigateDetail = (slug, product_id, cat_id, subCate_id) => {
        const encodedCatId = btoa(subCate_id);
        const decodedId = atob(encodedCatId);
        navigate(`/product/${slug}`);
    }

    const faqPages = sub_Cate_obj?.category_page?.filter(page => page.page_name?.toLowerCase() === "faq") || [];
    const nonFaqPages = sub_Cate_obj?.category_page?.filter(page => page.page_name?.toLowerCase() !== "faq") || [];

    // Set a unique "FAQ" tab ID
    const FAQ_TAB_ID = "faq-tab";

    const toggleAccordion = (id) => {
        setActiveAccordion(id === activeAccordion ? null : id);
    };

    return (
        <>
            <Helmet>
                <title>{sub_Cate_obj?.meta_title}</title>
                <meta name="description" content={sub_Cate_obj?.meta_desc
                    || "description"} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}${cat_obj?.slug}/${sub_Cate_obj?.slug}`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}${cat_obj?.slug}/${sub_Cate_obj?.slug}`} />

            </Helmet>
            {/* <--------- Header section's ------> */}
            <Header />
            {/* <-------- ToastContainer ------------> */}
            {/* <ToastContainer style={{ marginTop: "120px" }} /> */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        {/* <----------- Category_Main_Banner section's------> */}
                        {/* <Category_Main_Banner data={sub_category_result} /> */}

                        <div className="bg-gray-50 px-3 md:pt-6 pb-3">
                            <div className="flex flex-wrap w-full mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="pt-1 product_list_subdecr w-full inline-block">
                                    <ul className="flex flex-wrap items-center gap-3">
                                        <li className="text-gray-700"><Link to={"/"} className="text-[11px]">Home</Link></li>
                                        <li className="text-gray-700 text-[11px]">/</li>
                                        <li className="text-gray-700 capitalize"><Link
                                            to={`/${cat_obj?.slug}`}
                                            className="text-[12px]"
                                        >
                                            {cat_obj?.title}
                                        </Link></li>
                                        <li className="text-gray-700 text-[12px]">/</li>
                                        <li className="text-gray-700 !text-[12px]">{sub_Cate_obj?.title
                                        }</li>
                                    </ul>
                                </div>
                                <div className="md:flex gap-5 mt-3">
                                    <div className='text-center md:text-end max-w-[160px] mb-3'>
                                        <img className="w-full md:ml-auto rounded-lg" src={`${IMG_BASE_URL}${sub_Cate_obj?.image}
`} alt={sub_Cate_obj?.image_alt} />
                                    </div>
                                    <div className="">
                                        <h2 className="text-lg font-semibold text-gray-950">{sub_Cate_obj?.title
                                        }</h2>
                                        <div className="border-b-2 border-b-black  w-[140px] mb-3"></div>
                                        {
                                            sub_Cate_obj?.sort_description
                                            && (
                                                <div className="sub__title text-sm product_list_subdecr check_arro mt-2  overflow-hidden text-justify"
                                                    dangerouslySetInnerHTML={{ __html: sub_Cate_obj.sort_description }} />
                                            )
                                        }

                                        {/* category pages listing */}
                                        <ul className="flex flex-wrap gap-8 mt-3 w-full">
                                            {/* Non-FAQ Tabs */}
                                            {nonFaqPages.map((category_page_result) => (
                                                <li
                                                    key={category_page_result?.id}
                                                    onClick={() => handleCategoryPage(category_page_result?.id)}
                                                >
                                                    <span
                                                        className={`${categoryPage === category_page_result?.id
                                                            ? "text-red-800"
                                                            : "text-dark"
                                                            } font-semibold text-[13px] capitalize cursor-pointer hover:text-red-800`}
                                                    >
                                                        {category_page_result?.page_name}
                                                    </span>
                                                </li>
                                            ))}

                                            {/* FAQ Tab (only one shown) */}
                                            {faqPages.length > 0 && (
                                                <li onClick={() => handleCategoryPage(FAQ_TAB_ID)}>
                                                    <span
                                                        className={`${categoryPage === FAQ_TAB_ID
                                                            ? "text-red-800"
                                                            : "text-dark"
                                                            } font-semibold text-[13px] capitalize cursor-pointer hover:text-red-800`}
                                                    >
                                                        FAQ
                                                    </span>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* category_pages */}
                        {sub_Cate_obj?.category_page?.length > 0 && (
                            <section className="bg-white">
                                <div className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                    <div className="flex flex-wrap w-full">
                                        <div className="w-full mt-4 bg-white">
                                            {/* Non-FAQ pages */}
                                            {nonFaqPages.map((page) => {
                                                const isActive = categoryPage === page.id;
                                                let imageList = [];

                                                try {
                                                    imageList = Array.isArray(page.image)
                                                        ? page.image
                                                        : JSON.parse(page.image || "[]");
                                                } catch (err) {
                                                    console.error(
                                                        "Error parsing image JSON for page:",
                                                        page.page_name,
                                                        err
                                                    );
                                                }

                                                return (
                                                    <div
                                                        key={page.id}
                                                        className={`bg-white px-6 ${!isActive ? "hidden" : "block"
                                                            }`}
                                                    >
                                                        <div className="text-dark font-semibold mb-2">
                                                            {page?.page_title}
                                                        </div>

                                                        {imageList.length > 0 && (
                                                            <div className="grid grid-cols-3 gap-5">
                                                                {imageList.map((img, idx) => (
                                                                    <img
                                                                        key={idx}
                                                                        src={`${IMG_BASE_URL}${img}`}
                                                                        alt={`Page ${page.page_name} Image ${idx}`}
                                                                        className="rounded-lg w-full object-cover"
                                                                    />
                                                                ))}
                                                            </div>
                                                        )}

                                                        {page.description && (
                                                            <div
                                                                className="sub__title text-gray-900 text-sm prose prose-sm max-w-none product_about_desc"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: page.description,
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })}

                                            {/* FAQ Accordion Page (One Combined Section) */}
                                            {faqPages.length > 0 && categoryPage === FAQ_TAB_ID && (
                                                <div className="bg-white px-6">

                                                    <div className="accordion space-y-2">
                                                        {faqPages.map((faq, idx) => (
                                                            <>
                                                                <div id="accordion-collapse-heading-1" onClick={() => toggleAccordion(faq?.id)}>
                                                                    <button type="button" className="flex items-center justify-between w-full border-b border-gray-300 py-3 font-semibold text-[14px] focus:outline-0" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1">
                                                                        <span>{faq?.page_title}</span>
                                                                        <svg data-accordion-icon className={`size-2 shrink-0 ${activeAccordion == faq?.id ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                                <div id="accordion-collapse-body-1" className={`${activeAccordion == faq?.id ? 'block' : 'hidden'}`} aria-labelledby="accordion-collapse-heading-1">
                                                                    <div className="py-3 pt-1">
                                                                        <div className="w-full">
                                                                            <div id="gi-spt-nav-info" className="tab-single-pane">
                                                                                <div className="sub__title text-gray-800 text-[13px] font-medium" dangerouslySetInnerHTML={{ __html: ` ${faq?.description} ` }} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        )}


                        <section className="gi-category py-[40px] max-[767px]:py-[0px]">
                            <div className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="">
                                    {/* <!-- Sidebar Area Start --> */}
                                    <div className="gi-shop-sidebar px-3">
                                        <div id="shop_sidebar">
                                            <div className="gi-sidebar-wrap grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                                                {/* <!-- Sidebar Category Block --> */}
                                                <div ref={originRef} className="gi-sidebar-block relative">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <div className="text-red-700 text-lg flex justify-between items-center cursor-pointer">
                                                            {/* <span><i className="fi-rr-filter mr-2"></i> Filter</span> */}
                                                            <span className={`transform transition-transform ${is_Open_Origin ? "rotate-180" : ""}`}></span>
                                                        </div>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_origin_accordion}>Origin  <i class={`gicon gi-angle-down ${is_Open_Origin && 'rotate-180'}`}></i>
                                                        </h3>
                                                    </div>
                                                    {/* Accordion Content */}
                                                    {is_Open_Origin && (
                                                        <div className="gi-sb-block-content absolute top-12 left-0 right-0 z-20 bg-white border border-t-0 px-3">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.origin?.map((origin_result) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                        checked={selectedOrigins.includes(origin_result?.id)}
                                                                                        onChange={() => handle_origin_Checkbox_Change(origin_result?.id)}
                                                                                    />
                                                                                    <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                        <span className="flex">{origin_result?.name}</span>
                                                                                    </p>
                                                                                    <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedOrigins.includes(origin_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* <!-- Sidebar Shape Block --> */}
                                                <div ref={shapeRef} className="gi-sidebar-block relative ">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <span className={`transform transition-transform ${is_Open_Shape ? "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_Shape_accordion}>Shape <i class={`gicon gi-angle-down ${is_Open_Shape && 'rotate-180'}`}></i></h3>
                                                    </div>
                                                    {is_Open_Shape && (
                                                        <div className="gi-sb-block-content absolute top-12 left-0 right-0 z-20 bg-white border border-t-0 px-3">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.shape?.map((shape_result) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                        checked={selectedShape.includes(shape_result?.id)}
                                                                                        onChange={() => handle_shape_Checkbox_Change(shape_result?.id)}
                                                                                    />
                                                                                    <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                        <span className="flex">{shape_result?.name}</span>
                                                                                    </p>
                                                                                    <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedOrigins.includes(shape_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <!-- Sidebar Cut Block --> */}
                                                <div ref={cutRef} className="gi-sidebar-block relative">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <span className={`transform transition-transform ${is_Open_Cut ? "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_Cut_accordion}>Cut <i class={`gicon gi-angle-down ${is_Open_Cut && 'rotate-180'}`}></i></h3>
                                                    </div>
                                                    {is_Open_Cut && (
                                                        <div className="gi-sb-block-content absolute top-12 left-0 right-0 z-20 bg-white border border-t-0 px-3">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.cut?.map((cut_result) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                        checked={selectedCut.includes(cut_result?.id)}
                                                                                        onChange={() => handle_cut_Checkbox_Change(cut_result?.id)}
                                                                                    />
                                                                                    <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                        <span className="flex">{cut_result?.name}</span>
                                                                                    </p>
                                                                                    <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedCut.includes(cut_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <!-- Sidebar Certificate Block --> */}
                                                <div ref={certificateRef} className="gi-sidebar-block relative">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <span className={`transform transition-transform ${is_Open_Certificate ? "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_Certificate_accordion}>Certificate <i class={`gicon gi-angle-down ${is_Open_Certificate && 'rotate-180'}`}></i></h3>
                                                    </div>
                                                    {is_Open_Certificate && (
                                                        <div className="gi-sb-block-content absolute top-12 left-0 right-0 z-20 bg-white border border-t-0 px-3">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.certificate
                                                                        ?.map((certificate_result) => {
                                                                            return (
                                                                                <li>
                                                                                    <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                            checked={selectedCertificate.includes(certificate_result?.id)}
                                                                                            onChange={() => handle_certificate_Checkbox_Change(certificate_result?.id)}
                                                                                        />
                                                                                        <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                            <span className="flex">{certificate_result?.name}</span>
                                                                                        </p>
                                                                                        <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedCertificate.includes(certificate_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <!-- Sidebar Color item --> */}
                                                <div ref={colorRef} className="gi-sidebar-block relative">
                                                    <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                        <span className={`transform transition-transform ${is_Open_Color ? "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_color_accordion}>Color <i class={`gicon gi-angle-down ${is_Open_Color && 'rotate-180'}`}></i></h3>
                                                    </div>
                                                    {is_Open_Color && (
                                                        <div className="gi-sb-block-content absolute top-12 left-0 right-0 z-20 bg-white border border-t-0 px-3">
                                                            <ul>
                                                                {
                                                                    products?.filter_by?.color?.map((color_result) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                        checked={selectedColor.includes(color_result?.id)}
                                                                                        onChange={() => handle_color_Checkbox_Change(color_result?.id)}
                                                                                    />
                                                                                    <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                        <span className="flex">{color_result?.name}</span>
                                                                                    </p>
                                                                                    <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedColor.includes(color_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* <!-- Sidebar composition item --> */}
                                                <div className="gi-sidebar-block relative" onClick={() => set_Is_Open_filter(!is_Open_filter)}>
                                                    <div className={`gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee] ${is_Open_filter ? 'bg-[#e3e3e3]' : 'bg-white'} `}>
                                                        <span className={`transform transition-transform "rotate-180" : ""}`}></span>
                                                        <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                 flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]">{is_Open_filter ? 'Less Filters' : 'More Filters'} {is_Open_filter ? <i class="gicon fi-rr-minus"></i> : <i class="gicon fi-rr-plus"></i>}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            {is_Open_filter && (
                                                <div className="gi-sidebar-wrap grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mt-3">
                                                    <div ref={compositionRef} className="gi-sidebar-block relative">
                                                        <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                            <span className={`transform transition-transform ${is_Open_Composition ? "rotate-180" : ""}`}></span>
                                                            <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_composition_accordion}>Composition <i class={`gicon gi-angle-down ${is_Open_Composition && 'rotate-180'}`}></i></h3>
                                                        </div>
                                                        {is_Open_Composition && (
                                                            <div className="gi-sb-block-content absolute top-12 left-0 right-0 z-20 bg-white border border-t-0 px-3">
                                                                <ul>
                                                                    {
                                                                        products?.filter_by?.composition
                                                                            ?.map((composition_result) => {
                                                                                return (
                                                                                    <li>
                                                                                        <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                                checked={selectedComposition.includes(composition_result?.id)}
                                                                                                onChange={() => handle_composition_Checkbox_Change(composition_result?.id)}
                                                                                            />
                                                                                            <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                                <span className="flex">{composition_result?.name}</span>
                                                                                            </p>
                                                                                            <span className={`checked absolute top-1/2 left-0 h-4 w-4 bg-white border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedComposition.includes(composition_result?.id) ? "bg-red-500 border-red-500" : ""}`}></span>
                                                                                        </div>
                                                                                    </li>
                                                                                )
                                                                            })
                                                                    }
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* <!-- Sidebar Composition item --> */}
                                                    <div ref={treatmentRef} className="gi-sidebar-block relative">
                                                        <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                            <span className={`transform transition-transform ${is_Open_treatment ? "rotate-180" : ""}`}></span>
                                                            <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                                                                flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_treatment_accordion}>Treatment <i class={`gicon gi-angle-down ${is_Open_treatment && 'rotate-180'}`}></i></h3>
                                                        </div>
                                                        {is_Open_treatment && (
                                                            <div className="gi-sb-block-content absolute top-12 left-0 right-0 z-20 bg-white border border-t-0 px-3">
                                                                <ul>
                                                                    {
                                                                        products?.filter_by?.treatment?.map((treatment_result) => {
                                                                            return (
                                                                                <li>
                                                                                    <div className="gi-sidebar-block-item py-[5px] relative flex flex-row">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="w-full h-full absolute opacity-0 cursor-pointer z-10"
                                                                                            checked={selectedTreatment.includes(treatment_result?.id)}
                                                                                            onChange={() => handle_treatment_Checkbox_Change(treatment_result?.id)}
                                                                                        />
                                                                                        <p className="w-full text-gray-500 text-[12px] mt-[0] leading-[20px] capitalize cursor-pointer flex justify-between pl-[25px]">
                                                                                            <span className="flex">{treatment_result?.name}</span>
                                                                                        </p>
                                                                                        <span
                                                                                            className={`checked absolute top-1/2 left-0 h-4 w-4  border border-gray-200 transition-transform transform -translate-y-1/2 rounded ${selectedTreatment.includes(treatment_result?.id) ? "bg-red-500 border-red-500" : ""
                                                                                                }`}
                                                                                        />
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        })
                                                                    }
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* <!-- Sidebar Price Block --> */}
                                                    <div ref={priceRef} className="gi-sidebar-block relative">
                                                        <div className="gi-sb-title border py-4 px-4 border-solid cursor-pointer border-[#eee]">
                                                            <span className={`transform transition-transform ${is_Open_price ? "rotate-180" : ""}`}></span>
                                                            <h3 className="gi-sidebar-title font-semibold tracking-[0] relative text-[#4b5966] w-full
                                                                                                                flex justify-between font-Poppins text-[12px] uppercase leading-[1.2]" onClick={toggle_treatment_price}>Filter By Price <i class={`gicon gi-angle-down ${is_Open_price && "rotate-180"}`}></i></h3>
                                                        </div>
                                                        {is_Open_price && (
                                                            <div className="gi-sb-block-content absolute top-12 left-0 right-0 z-10 bg-white border border-t-0 px-3">
                                                                <div className="gi-price-filter flex flex-col">
                                                                    <div className="gi-price-input mt-4 mb-3">

                                                                        <div className="flex pricefilter items-center relative">
                                                                            <RangeSlider min={0}
                                                                                max={100000} value={price} onInput={setPrice} className={"range-slider__range range-slider__thumb"} />
                                                                        </div>
                                                                        <div className="pricefilter flex justify-between text-gray-600 text-[10px] mt-4">
                                                                            <span>Min:</span>
                                                                            <span>Max:</span>
                                                                        </div>
                                                                        <div className='pricefilter flex justify-between gap-3 text-[10px] w-full'>
                                                                            <input type="number" value={JSON.parse(price[0])} className='w-[50%] border border-gray-400 text-center rounded-md ' onChange={handleMinChange} />
                                                                            <input type="number" value={JSON.parse(price[1])} className='w-[50%] border border-gray-400 text-center rounded-md ' onChange={handleMaxChange} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="gi-shop-rightside px-3">
                                        <div className="gi-pro-list-top md:flex items-center justify-between text-[14px] mb-[15px]">
                                            <div className="w-full gi-grid-list text-center pt-10 pb-6 border-b border-gray-200 mb-3">
                                                <h1 className="text-xl text-dark font-semibold mb-1">{sub_Cate_obj?.product_heading}</h1>
                                                <p className="text-[12px] text-dark font-medium">{sub_Cate_obj?.product_sub_heading}</p>

                                            </div>
                                        </div>
                                        {/* <!-- Shop content Start --> */}
                                        {
                                            currentProduct?.length > 0 ? (
                                                <div className="shop-pro-content">
                                                    <div className="shop-pro-inner">
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 w-full gap-4">
                                                            {
                                                                currentProduct?.map((product_list_result) => {
                                                                    const isOutOfStock = product_list_result?.current_stock <= 0;
                                                                    return (
                                                                        <div className={`w-full gi-product-box pro-gl-content  ${isOutOfStock ? "opacity-50 pointer-events-none group" : ""}`}>
                                                                            <div className="gi-product-content h-full">
                                                                                <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out overflow-hidden rounded-[5px]  hover:shadow-lg">
                                                                                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                                                                                        <div className="gi-pro-image overflow-hidden cursor-pointer"
                                                                                        >
                                                                                            {
                                                                                                product_list_result?.is_favourite === true ? (
                                                                                                    <span className="flags flex flex-col cursor-pointer items-center justify-center uppercase border rounded-full h-8 w-8 hover:bg-gray-200 absolute top-[5px] right-[15px] z-[2]">
                                                                                                        <img className="main-image w-[18px] h-[18px] transition-all duration-[0.3s] ease delay-[0s]"
                                                                                                            src={Common_Images_Transport?.wish_list} alt="Wishlist_img"
                                                                                                            onClick={() => Handle_add_to_favorite(product_list_result?.id, product_list_result?.cat_id, product_list_result?.sub_id)} />

                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <span className="flags flex flex-col bg-white h-8 w-8 items-center justify-center border rounded-full hover:bg-gray-200 cursor-pointer uppercase absolute top-[5px] right-[15px] z-[2]">
                                                                                                        <i onClick={() => Handle_add_to_favorite(product_list_result?.id, product_list_result?.cat_id, product_list_result?.sub_id)}
                                                                                                            className="fi-rr-heart transition-all text-[15px] duration-[0.3s]  ease-in-out text-[#777] leading-[10px]"></i>
                                                                                                    </span>
                                                                                                )
                                                                                            }
                                                                                            {
                                                                                                product_list_result?.product_images?.find(img => img.file_type == "video") && (
                                                                                                    <span onClick={() => handlePlay_Video(
                                                                                                        product_list_result?.product_images?.find(img => img.file_type === "video")?.video_url
                                                                                                    )} className="flags flex flex-col h-8 w-8 bg-white items-center justify-center border rounded-full hover:bg-gray-200 cursor-pointer uppercase absolute top-[5px] right-[60px] z-[2]">
                                                                                                        <i
                                                                                                            className="fi-rr-play transition-all text-[15px] duration-[0.3s] ease-in-out text-[#777] leading-[10px]"></i>
                                                                                                    </span>
                                                                                                )
                                                                                            }
                                                                                            <div onClick={() => {
                                                                                                handleNavigateDetail(product_list_result?.slug, product_list_result?.id, cat_obj?.id, sub_Cate_obj?.id)
                                                                                            }}>
                                                                                                <Link className="image productimg7 relative block overflow-hidden pointer-events-none" >

                                                                                                    {(() => {
                                                                                                        const imageList = product_list_result?.product_images
                                                                                                            ?.filter(item => item.file_type === 'image')
                                                                                                            ?.slice(0, 2); // Get only first 2 images

                                                                                                        return (
                                                                                                            <>
                                                                                                                <img
                                                                                                                    className="object-cover h-[200px] transition-all duration-[0.3s] ease delay-[0s] "
                                                                                                                    src={`${IMG_BASE_URL}${imageList[0]?.image_url}`}
                                                                                                                    alt={product_list_result?.alt_image_title || 'Product Image'}
                                                                                                                />



                                                                                                                {/* <img
                                                                                                                    className="first_pro_hover main-image object-cover h-[250px] transition-all duration-[0.3s] ease delay-[0s]  "
                                                                                                                    src={`${IMG_BASE_URL}${imageList[1]?.image_url}`}
                                                                                                                    alt={product_list_result?.alt_image_title || 'Product Image'}
                                                                                                                /> */}
                                                                                                            </>
                                                                                                        );
                                                                                                    })()}

                                                                                                </Link>
                                                                                            </div>
                                                                                            {isOutOfStock && (
                                                                                                <div className="absolute top-2 left-2 bg-red-600 text-white text-[12px] px-2 py-1 rounded">
                                                                                                    Out of Stock
                                                                                                </div>
                                                                                            )}

                                                                                        </div>
                                                                                    </div>

                                                                                    {/* product videos */}
                                                                                    {
                                                                                        show_video == true && (
                                                                                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/10 backdrop-blur-[2px]">
                                                                                                <div className='relative'>
                                                                                                    {/* Close Button */}
                                                                                                    <button
                                                                                                        onClick={() => set_show_video(false)}
                                                                                                        className="absolute -top-6 -right-6 text-white bg-black bg-opacity-60 rounded-full w-8 h-8 flex items-center justify-center text-xl hover:bg-opacity-80 z-30"
                                                                                                    >
                                                                                                        &times;
                                                                                                    </button>

                                                                                                    {/* Video Modal */}
                                                                                                    <div className="w-full max-w-[500px] h-auto rounded-lg overflow-hidden shadow-lg relative">
                                                                                                        <video
                                                                                                            autoPlay
                                                                                                            loop
                                                                                                            muted
                                                                                                            controls
                                                                                                            className="w-full h-full object-cover"
                                                                                                        >
                                                                                                            <source src={video} type="video/mp4" />
                                                                                                        </video>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    }                                                                              {/* <!-- custome jewellery design --> */}
                                                                                    <div className="w-[70%] mx-auto h-1 bg-gray-100 rounded-[100%]"></div>
                                                                                    <div className="gi-pro-content h-full p-[30px] pt-[0] relative z-[10] text-center">
                                                                                        <h5 className="gi-pro-stitle line-clamp-1 mt-4 text-gray-800 uppercase text-[14px] font-semibold leading-[1.2] cursor-pointer"
                                                                                            onClick={() => {
                                                                                                handleNavigateDetail(product_list_result?.slug, product_list_result?.id, cat_obj?.id, sub_Cate_obj?.id)
                                                                                            }}
                                                                                        >
                                                                                            {product_list_result?.name}
                                                                                        </h5>

                                                                                        {product_list_result?.origin?.name && (
                                                                                            <div className="gi-pro-rat-price  mb-[0] flex flex-col">
                                                                                                <span className="gi-price">
                                                                                                    <span className="new-price text-[#000] font-medium text-[13px]">
                                                                                                        <span>Origin: </span>
                                                                                                        <span className='text-gray-500'>{product_list_result?.origin?.name}</span>
                                                                                                    </span>
                                                                                                </span>
                                                                                            </div>
                                                                                        )}

                                                                                        <div className="flex flex-col mt-1 justify-center gap-1 items-center">
                                                                                            <div className="flex gap-2 items-center">
                                                                                                <span className="new-price text-[#000] font-semibold text-[13px]">
                                                                                                    Rs.{product_list_result?.seller_price}
                                                                                                </span>

                                                                                                {product_list_result?.discount && <span className="new-price text-gray-400 font-medium text-[13px] line-through">
                                                                                                    Rs.{product_list_result?.purchase_price}
                                                                                                </span>}

                                                                                                {/* {product_list_result?.discount && <span className="new-price text-red-600 font-semibold text-[10px]">
                                                                                                    {product_list_result?.discount} {product_list_result?.discount_type} OFF
                                                                                                </span>} */}
                                                                                            </div>
                                                                                            <div className="flex justify-center gap-3">
                                                                                                {/* {!isOutOfStock ? (
                                                                                                    <>
                                                                                                        <button
                                                                                                            onClick={() => {
                                                                                                                handleNavigateDetail(product_list_result?.slug, product_list_result?.id, cat_obj?.id, sub_Cate_obj?.id)
                                                                                                            }}
                                                                                                            type="button"
                                                                                                            className="text-[12px] uppercase border border-gray-200 text-gray-900 font-semibold px-3 py-2 hover:bg-gray-300"
                                                                                                        >
                                                                                                            View Details
                                                                                                        </button>

                                                                                                        {(cat_obj?.id !== 1 && cat_obj?.id !== 2) && (
                                                                                                            <button
                                                                                                                onClick={() => {
                                                                                                                    Handle_Add_To_cart(product_list_result);
                                                                                                                }}
                                                                                                                type="button"
                                                                                                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-3 py-2 hover:bg-gray-300 ml-2"
                                                                                                            >
                                                                                                                Add Cart
                                                                                                            </button>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (<button
                                                                                                    type="button"
                                                                                                    className={`text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-3 py-2 hover:bg-gray-300 `} disabled={isOutOfStock} >
                                                                                                    Not Available
                                                                                                </button>)} */}
                                                                                                {/* {isOutOfStock && (
                                                                                                    <button
                                                                                                    type="button"
                                                                                                    className={`text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-3 py-2 hover:bg-gray-300 `} disabled={isOutOfStock} >
                                                                                                    Not Available
                                                                                                </button>
                                                                                                )} */}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    {/* <!-- Pagination Start --> */}
                                                    <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                        <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, products?.product?.length)} of {products?.product?.length} Products</span>
                                                         <ul className="gi-pro-pagination-inner flex gap-1">
                                                             {currentPage > 1 && (
                                                                 <li>
                                                                     <button
                                                                         onClick={handlePrev}
                                                                         className="next w-auto text-[#fff] bg-[#5caf90] bg-red-500 text-[14px] px-2 rounded"
                                                                     >
                                                                         Prev
                                                                     </button>
                                                                 </li>
                                                             )}
                                                             {getPaginationItems().map((page, index) => {
                                                                 if (page === '...') {
                                                                     return (
                                                                         <li key={`ellipsis-${index}`} className="inline-block float-left">
                                                                             <span className="transition-all duration-[0.3s] ease-in-out text-[#777] text-[14px]">
                                                                                 ...
                                                                             </span>
                                                                         </li>
                                                                     );
                                                                 }
                                                                 return (
                                                                     <li key={page} className="inline-block float-left">
                                                                         <button
                                                                             onClick={() => handlePageChange(page)}
                                                                             className={`transition-all duration-[0.3s] ease-in-out font-light 
                                                                                 text-[#777] bg-[#eee] px-2
                                                                                 text-[14px] rounded
                                                                                 ${currentPage === page ? 'active bg-red-500 text-white' : 'bg-gray-300 text-black'}`}
                                                                         >
                                                                             {page}
                                                                         </button>
                                                                     </li>
                                                                 );
                                                             })}
                                                             {currentPage < totalPages && (
                                                                 <li>
                                                                     <button
                                                                         onClick={handleNext}
                                                                         className="next w-auto text-[#fff] px-2 bg-[#5caf90] text-[14px] rounded"
                                                                     >
                                                                         Next
                                                                     </button>
                                                                 </li>
                                                             )}
                                                         </ul>

                                                    </div>

                                                </div>
                                            ) : (
                                                <div className="w-full flex flex-col items-center justify-center text-center py-16 px-6 bg-white rounded-2xl border border-gray-100 shadow-sm max-w-md mx-auto my-8 animate-fadeIn">
                                                    <style>{`
                                                      @keyframes fadeIn {
                                                        from { opacity: 0; transform: translateY(10px); }
                                                        to { opacity: 1; transform: translateY(0); }
                                                      }
                                                      .animate-fadeIn {
                                                        animation: fadeIn 0.3s ease-out forwards;
                                                      }
                                                    `}</style>
                                                    <img
                                                        src={Common_Images_Transport?.emptyCart}
                                                        alt="No products available"
                                                        className="w-40 h-40 object-contain mb-6"
                                                    />
                                                    <h3 className="text-lg font-bold text-gray-950 mb-1.5">No Products Found</h3>
                                                    <p className="text-gray-500 text-xs sm:text-sm max-w-xs leading-relaxed">
                                                        Products are not available at the moment. Please check back later or try exploring another category.
                                                    </p>
                                                </div>
                                            )
                                        }
                                        {
                                            sub_Cate_obj?.description
                                            && (

                                                <div className="sub__title text-sm product_list_subdecr check_arro mt-3  overflow-hidden text-justify"
                                                    dangerouslySetInnerHTML={{ __html: sub_Cate_obj.description }} />

                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div>
                            {settingData && settingData[0]?.certificate_image && (
                                <img src={`${IMG_BASE_URL}${settingData[0]?.certificate_image}`} alt="certificate" className='w-full' />
                            )}
                        </div>
                        {/*  */}
                        <Footer />
                    </>
                )
            }
        </>
    )
}

export default Product_List